import { atom } from 'jotai';
import { WhiteLabelLogos } from '@/helpers/whiteLabel/theme';

/** Logos of the workspace that sent the document ("White Label"): the pages opened without a login show them instead of DataDoc ones */
export const whiteLabelLogosAtom = atom<WhiteLabelLogos>({});
